module["exports"] = [
  "CH",
  "CH",
  "CH",
  "DE",
  "AT",
  "US",
  "LI",
  "US",
  "HK",
  "VN"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/de_CH/address/country_code.js
// module id = 1151
// module chunks = 0